export default "__VITE_ASSET__BOJPixtR__"